export function downloadFilename(url) {
  if (typeof url !== 'string' || !url.trim()) return 'download';

  let path;
  try {
    path = new URL(url, 'https://download.invalid/').pathname;
  } catch (error) {
    path = url.split(/[?#]/)[0];
  }

  let filename = path.split('/').pop();
  try {
    filename = decodeURIComponent(filename);
  } catch (error) {
    // Preserve legacy filenames containing a literal percent sign.
  }

  filename = filename.replace(/[<>:"/\\|?*\x00-\x1f\x7f]/g, '_').replace(/[. ]+$/, '');
  if (!filename) return 'download';
  if (/^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\.|$)/i.test(filename)) {
    filename = `_${filename}`;
  }
  return filename;
}
